//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'm-agree-iterms',
  props: [
    'value'
  ],
  data () {
    return {
      checked: true
    }
  },
  methods: {
    changeChecked () {
      this.$emit('input', this.checked)
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/AgreeIterms.vue